import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Loader } from "@whoosh/design-system/src/components/display";

import {
  NewPatronEvents,
  NewPatronEventsQueryString,
} from "./components/NewPatronEvents";
import { NewPatronEventsQuery } from "./components/__generated__/NewPatronEventsQuery.graphql";

export const EventsScreen = () => {
  const [newPatronEventsQueryRef, loadNewPatronEventsQuery] =
    useQueryLoader<NewPatronEventsQuery>(NewPatronEventsQueryString);

  useEffect(() => {
    loadNewPatronEventsQuery({}, { fetchPolicy: "store-and-network" });
  }, [loadNewPatronEventsQuery]);

  return (
    <Suspense fallback={<Loader />}>
      {newPatronEventsQueryRef ? (
        <NewPatronEvents queryRef={newPatronEventsQueryRef} />
      ) : null}
    </Suspense>
  );
};
